import React, { useState, useEffect } from 'react';
import '../css/FenetreLimiteRequete.css';
import { FaExclamationTriangle } from 'react-icons/fa';

const FenetreLimiteRequete = ({ donneesFiltrees, selectedProfessions, selectedSousCategories }) => {
  const [afficherFenetre, setAfficherFenetre] = useState(false);
  const [fenetreVisible, setFenetreVisible] = useState(false);

  useEffect(() => {
    if (donneesFiltrees.length >= 3000) {
      setAfficherFenetre(true);
      setFenetreVisible(true);

      const minuteurDisparition = setTimeout(() => {
        setFenetreVisible(false);
        
        const minuteurSuppression = setTimeout(() => {
          setAfficherFenetre(false);
        }, 4000);
        
        return () => clearTimeout(minuteurSuppression);
      }, 5000);

      return () => clearTimeout(minuteurDisparition);
    }
  }, [donneesFiltrees]);

  useEffect(() => {
    
      setFenetreVisible(false);
      setAfficherFenetre(false);
    
  }, [selectedProfessions, selectedSousCategories]);
  if (!afficherFenetre) return null;

  return (
    <div className={`fenetre-limite ${fenetreVisible ? 'visible' : 'cachee'}`}>
      <div className="contenu-fenetre">
        <div className="icone-attention">
          <FaExclamationTriangle />
        </div>
        <p className="message-limite">
          Nous avons limité à 3000 le nombre d'établissements affichés
        </p>
      </div>
    </div>
  );
};

export default FenetreLimiteRequete;